import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Inspection } from '../../shared/models/index';

@Component({
    selector: 'inspection-new',
    templateUrl: './new.component.html',
    standalone: false
})
export class InspectionNewComponent implements OnInit {
  public inspection: Inspection = new Inspection('', '', '');
  @Output() public toggleSaveInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() public processing;

  editForm: UntypedFormGroup;

  constructor() {}

  ngOnInit(): void {}

  public updateInspection() {
    this.toggleSaveInspection.emit(this.inspection);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
